import * as adminApi from '../../services/adminApi.js';

export const createAdminDashboardSlice = (set, get) => ({
  // Dashboard state
  isLoading: false,
  error: null,
  totals: {
    today: 0,
    week: 0,
    month: 0
  },
  totalExpenses: 0,
  topSellingProducts: [],
  branchPerformance: [],
  activeTokens: 0,

  // ====== DASHBOARD ACTIONS ======

  /**
   * Load admin dashboard data
   */
  loadAdminDashboard: async () => {
    set((currentState) => ({
      admin: {
        ...currentState.admin,
        isLoading: true,
        error: null
      }
    }));

    try {
      const dashboardData = await adminApi.fetchAdminDashboardData();
      set((currentState) => ({
        admin: {
          ...currentState.admin,
          ...dashboardData,
          isLoading: false,
          error: null
        }
      }));
    } catch (error) {
      set((currentState) => ({
        admin: {
          ...currentState.admin,
          isLoading: false,
          error: error.message || 'Unable to load admin dashboard'
        }
      }));
    }
  }
});